<template>
  <div class="test_head">
    <el-row :gutter="10">
      <el-col :xs="8" :sm="8" :md="8" :lg="9" :xl="9">
        <p class="test_line"></p>
      </el-col>
      <el-col :xs="8" :sm="7" :md="6" :lg="5" :xl="4">
        <p class="justCenter" style="display: flex;">
          <span :class="title=='测试报名'?'test_center_left':'test_center_left1'" class="common_backgroundImg"></span>
          <span class="test_center">
            <h2 class="test_title">{{title}}</h2>
          </span>
<!--          <span class="test_center_right common_backgroundImg"></span>-->
        </p>
      </el-col>
      <el-col :xs="8" :sm="9" :md="10" :lg="10" :xl="11">
        <p class="test_line">
          <router-link :to="morePath">
            <a class="test_line_a" style="font-size:14px">查看更多&gt;</a>
          </router-link>
        </p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    title: String,
    morePath: String
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style lang="less" scoped>
.test_head {
  .test_line {
    height: 50px;
    border-bottom: 1.5px solid #c4c4c4;
    position: relative;
    .test_line_a {
      position: absolute;
      bottom: 4px;
      right: 2px;
      color: #b93229;
    }
  }
  .test_center_left,
  .test_center_right {
    display: inline-block;
    width: 100px;
    height: 74px;
    //background-image: url("/image/index/badmintonPlayer.png");
    background-image: url("/image/new/badmintonPlayer.png");
    background-size: contain;
  }

  .test_center_left1{
    display: inline-block;
    width: 100px;
    height: 74px;
    //background-image: url("/image/index/badmintonPlayer.png");
    background-image: url("/image/new/badmintonPlayer1.png");
    background-size: contain;
  }
  .test_center_left {
    background-position: 2px 2px;
  }
  .test_center_right {
    background-position: -225px 0px;
  }
  .test_center {
    display: inline-block;
    height: 74px;
    .test_title {
      display: inline-block;
      line-height: 60px;
      border-bottom: 2px solid #b93229;
      color: #b93229;
    }
  }
}
@media screen and (max-width: 1000px) {
  .test_center_left {
    display: none;
  }
  .test_center_right {
    display: none;
  }
  .justCenter {
    justify-content: center !important;
  }
}
@media screen and (max-width: 768px){
  .test_title{
    font-size: 20px;
    width:95px;
    text-align: center;
  }
}
</style>